import styled from 'styled-components'

const PolicyPrivacyContainer = styled.div`
  padding: 30px 0px;

  h2,
  h3,
  h4 {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 10px;
    line-height: 22px;
  }

  ul {
    margin-left: 40px;
  }
`

// eslint-disable-next-line import/prefer-default-export
export { PolicyPrivacyContainer }
